import { DB_NAME, DB_VERSION, DB_STORE_ORDERS } from "../constants";

function openDatabase() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);

    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(DB_STORE_ORDERS)) {
        db.createObjectStore(DB_STORE_ORDERS, { keyPath: "id" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function idbPutOrder(order) {
  const db = await openDatabase();
  const tx = db.transaction(DB_STORE_ORDERS, "readwrite");
  tx.objectStore(DB_STORE_ORDERS).put(order);
  return new Promise((res, rej) => {
    tx.oncomplete = () => res();
    tx.onerror = () => rej(tx.error);
  });
}

export async function idbGetAllOrders() {
  const db = await openDatabase();
  const tx = db.transaction(DB_STORE_ORDERS, "readonly");
  const store = tx.objectStore(DB_STORE_ORDERS);
  const req = store.getAll();
  return new Promise((res, rej) => {
    req.onsuccess = () => res(req.result || []);
    req.onerror = () => rej(req.error);
  });
}

export async function idbDeleteOrder(id) {
  const db = await openDatabase();
  const tx = db.transaction(DB_STORE_ORDERS, "readwrite");
  tx.objectStore(DB_STORE_ORDERS).delete(id);
  return new Promise((res, rej) => {
    tx.oncomplete = () => res();
    tx.onerror = () => rej(tx.error);
  });
}

export async function idbClearOrders() {
  const db = await openDatabase();
  const tx = db.transaction(DB_STORE_ORDERS, "readwrite");
  tx.objectStore(DB_STORE_ORDERS).clear();
  return new Promise((res, rej) => {
    tx.oncomplete = () => res();
    tx.onerror = () => rej(tx.error);
  });
}
